
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/about",
      function () {
        return require("private-next-pages/profile/about/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/about"])
      });
    }
  